export default __webpack_public_path__ + "static/media/ic_web_schedule.f980eae0.png";